import { CombinedGraphQLErrors, ServerError } from "@apollo/client";

import { ErrorType } from "types/Error";

const getNetworkErrorMessages = (error: ErrorType | undefined): string[] => {
  if (!ServerError.is(error)) {
    return [];
  }

  try {
    const body = JSON.parse(error.bodyText) as { errors?: { message: string }[] };
    return body.errors?.map(({ message }) => message) ?? [];
  } catch {
    return [];
  }
};

export const shouldShowAccountNotFoundError = (error: ErrorType | undefined): boolean =>
  getNetworkErrorMessages(error).includes("Account not found");

export const shouldShowAccountInactiveError = (error: ErrorType | undefined): boolean =>
  getNetworkErrorMessages(error).includes("Account is inactive");

export const shouldShowUnauthorizedError = (error: ErrorType | undefined) =>
  CombinedGraphQLErrors.is(error) &&
  error.errors &&
  error.errors.length > 0 &&
  error.errors.find((item) => item.message === "unauthorized" || item.message === "denied");
